// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var firstEntry2 = false;
function scrollDownAction2(topNumber, classHeader) {


    var logoHeader = document.querySelector('.js-scroll-logo img' ) || [];
    var getLogoUrl;
    var getDataLogo;

    if(logoHeader.length !== 0) {
        getLogoUrl = logoHeader.src || [];
        getDataLogo = logoHeader.getAttribute('data-scroll') || [];
    }

    var headerElement = document.querySelector('header' );

    if(!firstEntry2) {
        console.log(getDataLogo.length);
        if(getDataLogo.length > 0) {
            window.addEventListener('scroll', function () {

                if( pageYOffset > topNumber ) {
                    headerElement.classList.add( classHeader );
                    logoHeader.src = getDataLogo;
                } else {
                    headerElement.classList.remove( classHeader );
                    logoHeader.src = getLogoUrl;
                }

            });
        } else {
            window.addEventListener('scroll', function () {

                if( pageYOffset > topNumber ) {
                    headerElement.classList.add( classHeader );
                } else {
                    headerElement.classList.remove( classHeader );
                }

            });
        }
        firstEntry2 = true;
    }
}

(function(){
	let widthDevice = window.innerWidth;

	if(widthDevice > 600) {
		/* title animation */
	
		document.querySelectorAll('.title-js.fade-letter').forEach(element => {
			let words = element.textContent.split(' '); 
			let result = ''; 
			let delayIncrement = 0.1;
			let currentDelay = 0; 
		
			words.forEach(word => {
				let singleLetters = word.split(''); 
				singleLetters = singleLetters.map(letter => `<span>${letter}</span>`).join(''); 
				result += `<div class="word">${singleLetters}</div>`; 
				result += ' '; 
			});
		
			element.innerHTML = result.trim(); 
		
			let wordContainers = element.querySelectorAll('.word');
			currentDelay = 0; 
			wordContainers.forEach(wordContainer => {
				let spans = wordContainer.querySelectorAll('span'); 
				spans.forEach(span => {
					span.style.transitionDelay = `${currentDelay}s`;
					currentDelay += delayIncrement; 
				});
			});
		});
	}
	
	let itemsNavigation = document.querySelectorAll('.privary-navigation__item');

	itemsNavigation.forEach((item)=>{
		let span = document.createElement('span');
		if(item.querySelector('.submenu')){
			item.insertAdjacentElement('beforeend', span);
		}
		item.addEventListener('click', ()=>{
			if(item.querySelector('.submenu')){
				itemsNavigation.forEach((nav)=>{
					if(nav.querySelector('.submenu') && item != nav){
						nav.classList.remove('active');
						nav.querySelector('.submenu').classList.remove('show');
					}
				})
				item.classList.toggle('active');
				item.querySelector('.submenu').classList.toggle('show');
			}
		})
	})

    window.onload = function() {
		if(document.querySelector('.js-scroll-logo')){
			scrollDownAction2(60, 'scroll');
		}

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	document.querySelectorAll('.btn:not(.reset), .btn-white, .btn-alt, .btn-dark, .privary-navigation__item a').forEach((button)=>{
		let span = document.createElement('span');
		button.insertAdjacentElement('afterbegin', span);
	});

	if(document.querySelector('.form-module__submit button.btn')){
		let buttonsForms = document.querySelectorAll('.form-module__submit button.btn');
		buttonsForms.forEach((button)=>{
			let text = button.textContent;
			let span = document.createElement('span');
			button.innerHTML = "";
			button.textContent = text;
			button.insertAdjacentElement('afterbegin', span);
		})
	}

	if(document.querySelector('.signup-btn')){
		let textButton = document.querySelector('.signup-btn').textContent;
		let spanbtn = document.createElement('span');
		document.querySelector('.signup-btn').textContent = '';
		document.querySelector('.signup-btn').textContent = textButton;
		document.querySelector('.signup-btn').insertAdjacentElement('afterbegin', spanbtn);
	}

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_first_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_last_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	if(document.querySelector('.tabs__tab')){
		let allItemsTabs = document.querySelectorAll('.tabs__tab');
		let lastTab = null

		allItemsTabs.forEach((tab)=>{
			tab.addEventListener('click',()=>{
				if(lastTab){
					lastTab.classList.remove('active');
					lastTab.parentElement.classList.remove('active');
					lastTab.parentElement.querySelector('.tabs__content .text').classList.add('hidden');
				}
				tab.parentElement.classList.add('active');
				tab.classList.add('active');
				setTimeout(() => {
					tab.parentElement.querySelector('.tabs__content .text').classList.remove('hidden');
				}, 400);
				lastTab = tab;
			});
		})
		allItemsTabs[0].click();
	}

	if(document.querySelector('.accordion-posts--m__tab')){
		let allItemsTabsM = document.querySelectorAll('.accordion-posts--m__tab');
		let lastTabM = null

		allItemsTabsM.forEach((tab)=>{
			tab.addEventListener('click',()=>{
				if(lastTabM){
					lastTabM.classList.remove('active');
					lastTabM.parentElement.classList.remove('active');
					lastTabM.parentElement.querySelector('.accordion-posts--m__content .text').classList.add('hidden');
				}
				tab.parentElement.classList.add('active');
				tab.classList.add('active');
				setTimeout(() => {
					tab.parentElement.querySelector('.accordion-posts--m__content .text').classList.remove('hidden');
				}, 400);
				lastTabM = tab;
			});
		})

		allItemsTabsM[0].click();
	}

	document.querySelector('.js-open-menu').addEventListener('click', ()=>{
		if(widthDevice > 768){
		document.getElementById('menu').classList.add('show');
		}else{
			document.getElementById('menu-responsive').classList.add('show');
		}
	})
	
	document.querySelector('.js-close-menu').addEventListener('click', ()=>{
		document.getElementById('menu').classList.remove('show');
	})

	document.querySelector('.js-click-close-menu').addEventListener('click', ()=>{
		document.getElementById('menu').classList.remove('show');
	})

	document.querySelector('.js-close-menu-responsive').addEventListener('click', ()=>{
		document.getElementById('menu-responsive').classList.remove('show');
	})

	if(document.querySelector('.location')){
		let itemLocation = document.querySelectorAll('.location__each');
		let pointsLocation = document.querySelectorAll('.location__point, .location__point--hotel');
		let lastClickPoint = null;

		pointsLocation.forEach((point)=>{
			point.addEventListener('click', ()=>{
				let dataPoint = point.dataset.point;
				if(lastClickPoint){
					lastClickPoint.classList.remove('active');
				}
				point.classList.add('active');
				itemLocation.forEach((location)=>{
					location.classList.toggle('hidden', dataPoint != location.dataset.point);
				})
				lastClickPoint = point;
			})
		})
	}

	if(document.querySelector('.menus-quad__filter')){
		let tabsMenu = document.querySelectorAll('.menus-quad__filter ul li');
		let allMenus = document.querySelectorAll('.menus-quad__container .menus-quad__menu');
		let lastClickMenu = null;

		tabsMenu.forEach((tab)=>{
			tab.addEventListener('click', ()=>{
				let menuId = tab.dataset.menu;
				if(lastClickMenu){
					lastClickMenu.classList.remove('active');
				}
				tab.classList.add('active');
				allMenus.forEach((menu)=>{
					menu.classList.toggle('hidden', menuId != menu.dataset.menu);
				})
				lastClickMenu = tab;
			})
		})

		tabsMenu[0].click();
	}

	if(document.querySelector('.accordion-posts__items')){
		let tabsPosts = document.querySelectorAll('.accordion-posts__each');
		let imagesPosts = document.querySelectorAll('.accordion-posts__image');

		tabsPosts.forEach((tab)=>{
			tab.addEventListener('click',()=>{
				let dataEntry = tab.dataset.entry;
				tabsPosts.forEach((item)=>{
					if(item.querySelector('.accordion-posts__each--title').classList.contains('open')){
						item.querySelector('.accordion-posts__each--title').classList.remove('open');
						item.querySelector('.accordion-posts__each--content .copy').classList.add('hidden');
					}
				});
				tab.querySelector('.accordion-posts__each--title').classList.add('open');
				tab.querySelector('.accordion-posts__each--content .copy').classList.remove('hidden');
				imagesPosts.forEach((image)=>{
					image.classList.toggle('active', image.dataset.entry == dataEntry);
				})
			})
		})

		tabsPosts[0].click();
	}

	if(document.querySelector('.accordion-posts__items-m')){
		let tabsPosts = document.querySelectorAll('.accordion-posts__tabs-m li');
		let itemsPosts = document.querySelectorAll('.accordion-posts__each-m');
		let lastClickTabM = null;

		tabsPosts.forEach((tab)=>{
			tab.addEventListener('click',()=>{
				let dataTabm = tab.dataset.tab;
				if(lastClickTabM){
					lastClickTabM.classList.remove('active');
				}
				tab.classList.add('active');
				itemsPosts.forEach((item)=>{
					item.classList.toggle('hidden', item.dataset.tab != dataTabm);
				})
				lastClickTabM = tab;
			})
		})

		tabsPosts[0].click();
	}

	// if(document.querySelector('.virtual-tour')){
	// 	document.querySelectorAll('.virtual-tour').forEach((virtual)=>{
	// 		virtual.parentNode.classList.add('no-number');
	// 	})
	// }

	if(document.querySelector('.js-li-scroll')){
		let allScrolls = document.querySelectorAll('.js-li-scroll');

		allScrolls.forEach((itemlist)=>{
			itemlist.addEventListener('click', ()=>{
				let target = itemlist.dataset.scroll;
				let headerHeight = document.querySelector('header').offsetHeight + 50;
				let elementTitle = document.querySelector(`h2[data-scroll="${target}"], h3[data-scroll="${target}"]`);
				window.scrollTo({
					top: elementTitle.offsetTop - headerHeight,
					behavior: 'smooth'
				});
			})
		})
	};

	if(document.querySelector('.js-form-press')){		
		let showForm = document.querySelectorAll('.js-form-press');
		showForm.forEach((button)=>{
			button.addEventListener('click', (event)=>{
				let dataForm = event.currentTarget.dataset.form;
				document.getElementById(`form-press-${dataForm}`).classList.toggle('hidden');
			});
		});
	}

	// WRAP MODULE TABLES
	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	if(document.querySelector('.interactive-map__tab')){
		let tabsMap = document.querySelectorAll('.interactive-map__tab');
		let maps = document.querySelectorAll('.interactive-map__map');
		let lastHover = null;

		tabsMap.forEach((tab)=>{
			if(widthDevice > 1024){
				tab.addEventListener('mouseenter', ()=>{
					let dataMap = tab.dataset.map;
					if(lastHover){
						lastHover.classList.remove('active');
					}
					tab.classList.add('active');
					lastHover = tab;
					maps.forEach((map)=>{
						map.classList.toggle('active', map.dataset.map == dataMap);
					})
				})
			}else{
				tab.addEventListener('click', ()=>{
					let dataMap = tab.dataset.map;
					if(lastHover){
						lastHover.classList.remove('active');
					}
					tab.classList.add('active');
					lastHover = tab;
					maps.forEach((map)=>{
						map.classList.toggle('active', map.dataset.map == dataMap);
					})
				})
			}
		})
	}

	if(document.querySelector('.interactive-map__dropdown')){
		let selectMap = document.getElementById('select_map');
		let mapImages = document.querySelectorAll('.interactive-map__images img');
		let mapPoints = document.querySelectorAll('.interactive-map__item');

		selectMap.addEventListener('change', ()=>{
			let dataMap = selectMap.value;

			mapImages.forEach((image)=>{
				image.classList.toggle('active', image.dataset.map == dataMap);
			});

			mapPoints.forEach((point)=>{
				point.classList.toggle('hidden', point.dataset.map != dataMap);
			})
		})
	}

	const tablesResp = document.querySelectorAll('.capacity-chart__table table');
	if(tablesResp.length > 0){
		tablesResp.forEach( tablei=>{
			var tableresponsive = document.createElement('div');
			tableresponsive.classList.add('tableHold');
			tablei.parentNode.insertBefore( tableresponsive, tablei);
			tableresponsive.append(tablei);
			const ths = tablei.querySelectorAll('tr:first-child > *');
			tablei.querySelectorAll('tr + tr').forEach( (row)=>{
				const tds = row.querySelectorAll('td');
				let i = 0;
				for( i; i < tds.length; i++){
					tds[i].setAttribute('data-label', ths[i].textContent);
				}
			});
			
			const rowHeads = tablei.querySelectorAll('tr td:first-child');
			rowHeads.forEach( ele=>{
				ele.addEventListener('click',(ev)=>{
					ele.closest('tr').classList.toggle('active');
				})
			})
		});
	}

	if(document.querySelector('.expand-submenu')){
		document.querySelectorAll('.expand-submenu').forEach((expand)=>{
			expand.addEventListener('click', ()=>{
				expand.classList.toggle('active-menu');
				expand.nextElementSibling.classList.toggle('show');
			})
		})
	}

	if(document.querySelector('a.no-click')){
		let anchors = document.querySelectorAll('a.no-click');

		anchors.forEach((anchor)=>{
			anchor.addEventListener('click', (e)=>{
				e.preventDefault();
			})
		})
	}

	if(widthDevice < 600 && document.querySelector('.sub-menu__hold')){
		/* Submenu on mobile */
		function submenu(){
			var submenuHold = document.querySelectorAll('.sub-menu__hold');
			var allsublinks = document.querySelectorAll('.sub-menu a');
			if(allsublinks.length > 1){
				allsublinks.forEach(ele=>{
					ele.addEventListener('click', function(ev){
						if(ele.classList.contains('active')){
							ev.preventDefault();
						}
					});
				});
				var toggleBtn = document.querySelector('.sub-menu__toggle');
				if(toggleBtn){
					toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
					toggleBtn.addEventListener('click', function(){
						toggleBtn.parentElement.classList.toggle('open');
					});
				}
			}else if(submenuHold.length > 0){
				submenuHold[0].classList.add('d-none');
			}
			
		}
		submenu();
	}

	window.addEventListener('DOMContentLoaded', () => {
		const id = window.location.hash.slice(1); 
		console.log(id)
		if (id) {
		  const elemento = document.getElementById(id);
		  if (elemento) {
			elemento.click(); // Simula el click
		  }
		}
	  });

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

const countDown = function (elements) {

	for (const element of elements) {

		const date = element.dataset.date;
		let formats = element.dataset.formats;

		if (!date || !formats)
			return;

		formats = formats.split(',');
		const format = formats.map(format => `<div class="countdown-time"><span></span>${format}</div>`).join('');
		element.insertAdjacentHTML("beforeend", format);

		const countDownDate = new Date(date).getTime();

		const timer = () => {
			let now = new Date().getTime();
			let dateDiff = countDownDate - now;

			let time = {
				days: String(Math.floor(dateDiff / (1000 * 60 * 60 * 24))).padStart(2, '0'),
				hours: String(Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
				minutes: String(Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
				seconds: String(Math.floor((dateDiff % (1000 * 60)) / 1000)).padStart(2, '0')
			}

			time = Object.values(time);

			for (let i = 0; i < formats.length; i++) {
				element.getElementsByTagName("div")[i].getElementsByTagName("span")[0].textContent = time[i];
			}

			if (dateDiff < 0)
				clearInterval(timerInterval);
		}

		timer();

		const timerInterval = setInterval(timer, 1000);
	}

}
document.getElementsByClassName("js-countdown") && countDown(document.getElementsByClassName("js-countdown"));